import * as React from "react";
import { Hotel } from "main/javascripts/types/hotel";
import { DetailItem } from "main/javascripts/components/spot/DetailItem";
import { DetailItemText } from "main/javascripts/components/spot/DetailItemText";

export interface IProps {
  checkin?: Hotel.Checkin;
}

export const HotelCheckin: React.FC<IProps> = (
  props: IProps
): React.ReactElement | null => {
  const { checkin } = props;
  if (!checkin) {
    return null;
  }
  return (
    <DetailItem title="チェックイン">
      {checkin.beginTime ? (
        <DetailItemText>
          チェックイン開始時刻 : {checkin.beginTime}
        </DetailItemText>
      ) : (
        ""
      )}
      {checkin.endTime ? (
        <DetailItemText>
          チェックイン終了時刻 : {checkin.endTime}
        </DetailItemText>
      ) : (
        ""
      )}
      {checkin.minAge ? (
        <DetailItemText>最低チェックイン年 : {checkin.minAge}</DetailItemText>
      ) : (
        ""
      )}
      {checkin.instructions || checkin.specialInstructions ? (
        <DetailItemText>
          チェックインに関する特記事項 : <br />
          {checkin.instructions ? (
            <div dangerouslySetInnerHTML={{ __html: checkin.instructions }} />
          ) : (
            ""
          )}
          {checkin.instructions && checkin.specialInstructions ? <br /> : ""}
          {checkin.specialInstructions ? (
            <div
              dangerouslySetInnerHTML={{ __html: checkin.specialInstructions }}
            />
          ) : (
            ""
          )}
        </DetailItemText>
      ) : (
        ""
      )}
    </DetailItem>
  );
};
